<template>
  <Modal :show="open" :classes="classes" @closed="$emit('closed')">
    <template #header>
      <!-- This is just to give space for the close X at the top-->
      <br />
    </template>
    <template #body>
      <iframe
        data-not-lazy
        :src="videoUrl"
        frameborder="0"
        width="100%"
        height="350px"
        allow="fullscreen"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
      />
    </template>
  </Modal>
</template>

<script>
export default {
  name: 'VideoModal',
  components: {
    Modal: defineAsyncComponent(() => import('#common/components/Modal.vue')),
  },
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: Object,
      default: () => ({
        modalBody: '',
        modalDialog: '',
        modalFooter: '',
        modalHeader: '',
      }),
    },
  },
  emits: ['closed'],
}
</script>
